import { render, staticRenderFns } from "./SearchItemBox.vue?vue&type=template&id=27aa62c4&scoped=true&"
import script from "./SearchItemBox.vue?vue&type=script&lang=js&"
export * from "./SearchItemBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchItemBox.vue?vue&type=style&index=0&id=27aa62c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa62c4",
  null
  
)

export default component.exports